/* Montzel Wines - script do template de produto (PDP).
 *
 * UNICA feature: o botao "outra cena" dentro do <details> de cenas escondidas
 * (plano do catalogo real, decisao 1.4a). Nao entra no core de 16KB: carrega com
 * defer SO na PDP e so quando ha mais de uma cena escondida; teto proprio de 2KB
 * declarado em scripts/check-js-budget.mjs.
 *
 * Progressive enhancement de verdade: sem JS o <details> ja mostra a primeira cena
 * escondida (renderizada em Liquid, entao o Google tambem ve) e o botao simplesmente
 * nao existe. As demais cenas viajam num <template>, fora do fluxo, sem custo de
 * layout. Nada roda sozinho: a troca e sempre por clique (WCAG 2.2.2), o container
 * tem role="status" e a transicao e so uma opacidade curta.
 *
 * Emite `mw:cena-outra` em document para o beacon do Curador medir o criterio de
 * morte da feature (menos de 2% das sessoes de PDP clicando em 90 dias = sai).
 */
(function () {
  var box = document.querySelector('[data-mw-cenas]');
  if (!box) return;
  var alvo = box.querySelector('[data-mw-cena-atual]');
  var tpl = box.querySelector('[data-mw-cenas-extra]');
  if (!alvo || !tpl || !tpl.content) return;

  var fila = [alvo.innerHTML];
  var extras = tpl.content.querySelectorAll('p');
  for (var i = 0; i < extras.length; i++) fila.push(extras[i].innerHTML);
  if (fila.length < 2) return;

  var pos = 0;
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'mw-pdp-cena-outra';
  btn.textContent = box.getAttribute('data-txt-outra') || '';
  btn.addEventListener('click', function () {
    pos = (pos + 1) % fila.length;
    var proxima = fila[pos];
    alvo.style.opacity = '0';
    setTimeout(function () {
      alvo.innerHTML = proxima;
      alvo.style.opacity = '';
    }, 140);
    document.dispatchEvent(new CustomEvent('mw:cena-outra', { detail: { indice: pos } }));
  });
  box.appendChild(btn);
})();
